var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesDesktop3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1617 1.38965H4.81999C2.79494 1.38965 1.15332 3.03128 1.15332 5.05632V23.9764C1.15332 26.0014 2.79494 27.643 4.81999 27.643H35.1617C37.1867 27.643 38.8283 26.0014 38.8283 23.9764V5.05632C38.8283 3.03128 37.1867 1.38965 35.1617 1.38965Z",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7383 27.625V34.61",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2617 27.625V34.61",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75342 34.6099H32.2468",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.867 7.7334H7.80029C7.24801 7.7334 6.80029 8.18111 6.80029 8.7334V14.8001C6.80029 15.3524 7.24801 15.8001 7.80029 15.8001H13.867C14.4192 15.8001 14.867 15.3524 14.867 14.8001V8.7334C14.867 8.18111 14.4192 7.7334 13.867 7.7334Z",
    fill: "#AFD0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2002 7.7334H17.3335C16.7812 7.7334 16.3335 8.18111 16.3335 8.7334V14.8001C16.3335 15.3524 16.7812 15.8001 17.3335 15.8001H32.2002C32.7525 15.8001 33.2002 15.3524 33.2002 14.8001V8.7334C33.2002 8.18111 32.7525 7.7334 32.2002 7.7334Z",
    fill: "#AFD0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2003 16.5332H7.80029C7.24801 16.5332 6.80029 16.9809 6.80029 17.5332V19.9332C6.80029 20.4855 7.24801 20.9332 7.80029 20.9332H32.2003C32.7526 20.9332 33.2003 20.4855 33.2003 19.9332V17.5332C33.2003 16.9809 32.7526 16.5332 32.2003 16.5332Z",
    fill: "#AFD0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4998 2.86768C25.0462 2.86768 22.5889 3.74292 20.7542 5.50073L20.2891 5.95117C19.9156 6.3064 19.9046 6.89966 20.2598 7.27319C20.6187 7.64673 21.212 7.65771 21.5855 7.29883L22.0543 6.85205C24.9473 4.0835 30.0523 4.0835 32.9454 6.85205L33.4141 7.29883C33.7877 7.65771 34.3809 7.64673 34.7398 7.27319C35.095 6.89966 35.084 6.3064 34.7105 5.95117L34.2454 5.50073C32.4107 3.74292 29.9534 2.86768 27.4998 2.86768ZM27.4705 6.625C25.9983 6.63599 24.5372 7.2146 23.5264 8.32422L23.0577 8.84058C22.7061 9.22144 22.7317 9.81836 23.1163 10.1663C23.5008 10.5142 24.0941 10.4849 24.4419 10.1003L24.9107 9.59131C26.0753 8.31323 28.6534 8.19238 29.9717 9.47046C30.0853 9.44849 30.1988 9.4375 30.3123 9.4375C30.8104 9.4375 31.2864 9.63525 31.638 9.98682L31.8467 10.1956C31.8577 10.1846 31.8687 10.1772 31.8834 10.1663C32.2642 9.81836 32.2935 9.22144 31.942 8.84058L31.4732 8.32422C30.4185 7.17065 28.939 6.61401 27.4705 6.625ZM27.4998 10.375C27.0201 10.375 26.5403 10.5581 26.1741 10.9243C25.4417 11.6567 25.4417 12.8433 26.1741 13.5757C26.9066 14.3081 28.0931 14.3081 28.8255 13.5757C29.0232 13.3779 29.1624 13.1509 29.254 12.9055L28.9866 12.6382C28.4666 12.1182 28.3238 11.3564 28.5472 10.6973C28.2322 10.4849 27.866 10.375 27.4998 10.375Z",
    fill: "#0D6EFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 10.375C30.0635 10.375 29.8254 10.4739 29.6497 10.6497C29.2834 11.0159 29.2834 11.6091 29.6497 11.9753L30.8618 13.1875L29.6497 14.3997C29.2834 14.7659 29.2834 15.3591 29.6497 15.7253C30.0159 16.0916 30.6091 16.0916 30.9753 15.7253L32.1875 14.5132L33.3997 15.7253C33.7659 16.0916 34.3591 16.0916 34.7253 15.7253C35.0916 15.3591 35.0916 14.7659 34.7253 14.3997L33.5132 13.1875L34.7253 11.9753C35.0916 11.6091 35.0916 11.0159 34.7253 10.6497C34.5496 10.4739 34.3115 10.375 34.0625 10.375C33.8135 10.375 33.5754 10.4739 33.3997 10.6497L32.1875 11.8618L30.9753 10.6497C30.7996 10.4739 30.5615 10.375 30.3125 10.375Z",
    fill: "#0C1CAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesDesktop3);
export default __webpack_public_path__ + "static/media/devices-desktop-3.787fff7660487d0931c9c2d5ab4d82c3.svg";
export { ForwardRef as ReactComponent };